module.exports = __webpack_public_path__ + "static/img/ichat_phone2.81ce40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/ichat_phone2.png
// module id = 620
// module chunks = 0